import { create } from 'zustand';
import type { ManagedUser } from '@/types/users';

interface UsersState {
  users: ManagedUser[];
  customers: string[];
  loading: boolean;
  error: string | null;
  selectedUser: ManagedUser | null;
  isFormOpen: boolean;

  setUsers: (users: ManagedUser[]) => void;
  setCustomers: (customers: string[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setSelectedUser: (user: ManagedUser | null) => void;
  setFormOpen: (open: boolean) => void;
  openCreate: () => void;
  openEdit: (user: ManagedUser) => void;
  closeForm: () => void;
}

export const useUsersStore = create<UsersState>((set) => ({
  users: [],
  customers: [],
  loading: false,
  error: null,
  selectedUser: null,
  isFormOpen: false,

  setUsers: (users) => set({ users }),
  setCustomers: (customers) => set({ customers }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSelectedUser: (user) => set({ selectedUser: user }),
  setFormOpen: (open) => set({ isFormOpen: open }),
  openCreate: () => set({ selectedUser: null, isFormOpen: true }),
  openEdit: (user) => set({ selectedUser: user, isFormOpen: true }),
  closeForm: () => set({ selectedUser: null, isFormOpen: false }),
}));
